import { useCallback } from "react";
import { COOKIE_KEY_FULLSCREEN } from "@/shared/utils/theme/theme";
import { VIEW_MODE } from "@/shared/utils/viewmode";
import useCookiesWithOptions from "@/shared/hooks/useCookiesWithOptions";

const useFullScreen = () => {
  const [cookie, setCookie] = useCookiesWithOptions([COOKIE_KEY_FULLSCREEN]);
  const { fullScreen } = cookie;

  const updateFullScreen = useCallback(
    (stateNew, updateCookie) => {
      const classList = document.body.classList;
      if (updateCookie) {
        setCookie(COOKIE_KEY_FULLSCREEN, stateNew ? stateNew : "");
      }
      if (stateNew) {
        if (!classList.contains(VIEW_MODE.FULLSCREEN)) {
          classList.add(VIEW_MODE.FULLSCREEN);
        }
      } else {
        classList.remove(VIEW_MODE.FULLSCREEN);
      }
    },
    [setCookie],
  );

  const setFullScreen = useCallback(() => {
    updateFullScreen(fullScreen);
  }, [updateFullScreen, fullScreen]);

  const disableFullScreen = useCallback(() => {
    updateFullScreen(false);
  }, [updateFullScreen]);

  const toggleFullScreen = useCallback(() => {
    updateFullScreen(!fullScreen, true);
  }, [fullScreen, updateFullScreen]);

  return { fullScreen: Boolean(fullScreen), toggleFullScreen, setFullScreen, disableFullScreen };
};

export default useFullScreen;
